import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LandingPageMainContainer = styled("main")(
  () => `
    background: white;
  `
);

export const LandingPageSectionWrapper = styled("div")(
  () => `
    padding: 53px 27px;
    overflow: hidden;
    position: relative;

    &.landing-page__feature-section {
        background: #052F46;
    }
  `
);

export const HeroSection = styled("section")(
  () => `
    display: flex;
  `
);

export const HeroSectionLeft = styled("div")(
  () => `
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: center;
  `
);

export const HeroSectionRight = styled("div")(
  () => `
    width: 50%;
  `
);

export const HeroSectionImg = styled("img")(
  () => `
   width: 100%;
   @keyframes rotateAnimation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
   }
  animation: rotateAnimation 60s linear infinite ;
  `
);

export const HeroSectionLeftTitle = styled("h1")(
  () => `
  font-size: clamp(42px, 2.7vw, 100px);
  font-weight: 800;
  margin: 0;
  color: black;
  line-height: 119%;
  margin-bottom: 18px;
  width: 90%;
  `
);

export const HeroSectionLeftSubTitle = styled("p")(
  () => `
  font-size: clamp(16px, 1vw, 30px);
  color: #424242;
  padding: 0;
  margin: 0;
  width: 90%;
  `
);

export const CallToActionWrapper = styled("div")(
  () => `
    margin-top: 25px;
    display: flex;
    gap: 26px;
    align-items: center;
  `
);

export const PrimaryButton = styled(Button)(
  () => `
    padding: 0.72em 1.29em;;
    background: #EB0A1E;
    border-radius: 4px;
    border: none;
    outline: none;
    font-size: clamp(14px, 0.9vw, 30px);
    font-weight: bold;
    line-height: 112.2%;
    color: white;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: 5px;
    font-family: 'Toyota';
    &:hover {
      background: #EE2F40;
    }
    &.no-responsive {
      font-size: 14px;
    }
  `
);

export const SecondaryButton = styled("a")(
  () => `
    font-weight: 700;
    color: #EB0A1E;
    font-size: clamp(14px, 0.8vw, 18px);
  `
);

export const HeroSectionRightInside = styled("div")({
  width: "36.11vw",
  transform: "translateX(65%)",
});

export const HeroRightSectionCardWrapper = styled("div")(
  () => `
  background: #EEF1F6;
  border-radius: 61px;
  position: absolute;
  display: flex;
  min-height: 63px;

  &.hero_right_section_card_1 {
    top: 0;
    left: calc(36vw - 134%);
  }

  &.hero_right_section_card_2 {
    top: calc(36vw * 0.18);
    left: calc(36vw - 146%);
  }

  &.hero_right_section_card_3 {
    top: calc(36vw * 0.36);
    left: calc(36vw - 160%);
  }

  &.hero_right_section_card_4 {
    top: calc(36vw * 0.54);
    left: calc(36vw - 160%);
  }

  &.hero_right_section_card_5 {
    top: calc(36vw * 0.72);
    left: calc(36vw - 146%);
  }

  &.hero_right_section_card_6 {
    top: calc(36vw * 0.90);
    left: calc(36vw - 134%);
  }
`
);

export const HeroRightSectionIconBox = styled("div")(
  () => `
      width: clamp(70px, 4.5vw, 100px);
      height: auto;
      border-radius: 50%;
      border-top-right-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      &.hero_right_section_card_1_icon_box {
        background: #fb7334;
      }
      
      &.hero_right_section_card_2_icon_box {
        background: #26AA31;
      }

      &.hero_right_section_card_3_icon_box {
        background: #FACB35;
      }

      &.hero_right_section_card_4_icon_box {
        background: #47ACDF;
      }

      &.hero_right_section_card_5_icon_box {
        background: #085D8B;
      }

      &.hero_right_section_card_6_icon_box {
        background: #A829FB;
      }
`
);

export const HeroRightSectionIconBoxImg = styled("div")({
  zIndex: 2,
  position: "relative"
});

export const HeroRightSectionCardTitle = styled("div")({
  fontSize: "clamp(12px, 0.8vw, 18px)",
  fontWeight: "700",
});

export const HeroRightSectionCardDesc = styled("p")({
  margin: "0",
  fontSize: "clamp(12px, 0.8vw, 18px)",
  lineHeight: "112.2%",
});

export const HeroRightSectionCardContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "10px 15px",
});

export const FeatureSectionContent = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
  
export const SectionTitle = styled("h2")(() => `
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    color: white;
    margin: 0;
    margin-bottom: 15px;
    
    &.light-version-title {
      color: #424242;
    }
`);

export const SectionDescriptionWrapper = styled("div")({
    width: "65%"
});

export const SectionDescription = styled("p")({
    textAlign: "center",
    fontSize: "18px",
    color: "#E9E9E9",
    margin: 0
});

export const FeatureSectionCards = styled("ul")({
  display: "flex",
  gap: "29px",
  justifyContent: "center",
  width: "90%",
  margin: "66px auto",
  flexWrap: "wrap",
  maxWidth: "1004px",
  listStyle: "none",
});

export const FeatureSectionCard = styled("li")({
  borderRadius: "1000px",
  padding: "10px 28px",
  background: "rgba(44, 56, 82, 49)",
  width: "302px",
  display: "flex",
  alignItems: "center",
  flexShrink: "0",
  margin: "0"
});

export const FeatureSectionCardDesc = styled("span")({
  fontSize: "16px",
  color: "#FFFFFF",
  fontWeight: "700",
  marginLeft: "9px",
  lineHeight: "112.2%",
});

export const PlatformStatistics = styled("ul")({
  display: "flex",
  gap: "49px",
  justifyContent: "center",
  listStyle: "none"
});

export const PlatformStatistic = styled("li")(() => `
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 177px;

  & span:nth-child(1) {
    font-size: 36px;
    color: #EB0A1E;
    font-weight: 700;
  }

  & span:nth-child(2) {
    font-size: 18px;
    color: #ffffff;
    font-weight: 700;
    text-align: center;
  }
`);

export const PlatformStatisticSeprator = styled("div")({
  height: "110px",
  width: "1px",
  background: "#ffffff"
});

export const ServicesAvailableSectionItems = styled("ul")({
  listStyle: "none",
  display: "flex",
  alignItems: "center",
  gap: "77px",
  justifyContent: "center",
  margin: 0,
  marginTop: "15px",
});

export const PlatformOfferings = styled("ul")({
  display: "flex",
  justifyContent: "center",
  gap: "18px",
  maxWidth: "726px",
  flexWrap: "wrap",
  margin: "0 auto",
  marginTop: "38px",
});

export const PlatformOffering = styled("li")({
  width: "146px",
  height: "92px",
  border: "1px solid white",
  borderRadius: "4px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
});

export const PlatformOfferingContent = styled("span")({
  fontSize: "12px",
  marginTop: "8px",
  fontWeight: "500",
  color: "white",
});

export const PlatformOfferingBg1 = styled("img")({
  position: "absolute",
  top: "-10%",
  right: "-3%",
  width: "clamp(287px, 10vw, 350px)"
});

export const PlatformOfferingBg2 = styled("img")({
  position: "absolute",
  bottom: "-10%",
  left: "-3%",
  width: "clamp(276px, 10vw, 350px)"
});
